(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-vitaly"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vitaly-header')) {
    class VitalyHeader extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.vh-panel');

        this.querySelectorAll('[data-vh-toggle]').forEach((btn) => {
          btn.addEventListener('click', () => this.toggle());
        });

        this.querySelectorAll('[data-vh-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });

        this.onKeydown = (e) => {
          if (e.key === 'Escape') this.close();
        };

        const drawerCart = this.querySelector('[data-vh-cart]');
        if (drawerCart) {
          drawerCart.addEventListener('click', () => {
            this.close();
            const cartIcon = document.getElementById('cart-icon-bubble');
            if (cartIcon) {
              cartIcon.click();
            } else {
              window.location.href = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart' : '/cart';
            }
          });
        }

        this.syncCartCount();
      }

      toggle() {
        this.classList.contains('vh-open') ? this.close() : this.open();
      }

      open() {
        // Borde inferior real del header en el viewport (incluye barras de anuncio encima)
        document.documentElement.style.setProperty('--vh-header-h', Math.max(0, this.getBoundingClientRect().bottom) + 'px');
        this.classList.add('vh-open');
        this.querySelectorAll('[data-vh-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this.onKeydown);
      }

      close() {
        if (!this.classList.contains('vh-open')) return;
        this.classList.remove('vh-open');
        this.querySelectorAll('[data-vh-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this.onKeydown);
      }

      // Mantiene el contador del drawer sincronizado cuando el tema
      // re-renderiza #cart-icon-bubble tras agregar al carrito.
      syncCartCount() {
        const mainCart = this.querySelector('#cart-icon-bubble');
        const drawerCount = this.querySelector('[data-vh-cart-count]');
        if (!mainCart || !drawerCount) return;

        const sync = () => {
          const bubble = mainCart.querySelector('.cart-count-bubble span[aria-hidden]');
          const count = bubble ? bubble.textContent.trim() : '';
          drawerCount.textContent = count || '0';
          drawerCount.classList.toggle('is-hidden', !count || count === '0');
        };

        new MutationObserver(sync).observe(mainCart, { childList: true, subtree: true });
      }
    }

    customElements.define('vitaly-header', VitalyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
